"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchManager = void 0;
const axios_1 = __importDefault(require("axios"));
const lit_html_1 = require("lit-html");
axios_1.default.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
const typedi_1 = require("typedi");
const category_1 = require("@category/services/category");
const domain_1 = require("@domain/services/domain");
const ga_1 = require("@common/services/ga");
const translation_1 = require("@translation/services/translation");
const loader_1 = require("@common/loader/loader");
const dom_1 = require("@common/utils/dom");
const categories_1 = require("../templates/categories");
const achievements_1 = require("@domain/templates/achievements");
const primary_1 = require("@domain/templates/primary");
const primary_third_level_1 = require("@domain/templates/primary-third-level");
const simple_1 = require("@domain/templates/simple");
/**
 * Менеджер поиска
 */
let SearchManager = class SearchManager {
    /**
     * Конструктор
     */
    constructor() {
        /**
         * Сдвиг по поиску
         */
        this.offset = -1;
        /**
         * Загрузка
         */
        this.loading = false;
        /**
         * Домены
         */
        this.domains = [];
        /**
         * Ошибка
         */
        this.error = false;
        /**
         * Конец списка
         */
        this.end = false;
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.categoryService = typedi_1.Container.get(category_1.CategoryService);
        this.domainService = typedi_1.Container.get(domain_1.DomainService);
    }
    /**
     * Инициализирует состояние
     */
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loader = new loader_1.Loader('.js-loader', this.translationService);
            let categories = [];
            this.registerChangeInputSearch();
            try {
                yield this.loadDomains(this.getQuery());
                const { data: { items } } = yield this.categoryService.getSearchList();
                categories = items;
            }
            catch (err) {
                return;
            }
            this.renderCategories(categories);
            this.registerScrollHandler();
            (0, simple_1.registerDomainCardClick)();
        });
    }
    /**
     * Возвращает исходный текст запроса
     */
    getEnteredQuery() {
        var _a;
        if (!this.input) {
            this.input = document.querySelector('.search__field') || undefined;
        }
        return ((_a = this.input) === null || _a === void 0 ? void 0 : _a.value) || '';
    }
    /**
     * Возвращает текст запроса
     */
    getQuery() {
        let enteredQuery = this.getEnteredQuery();
        let thirdLevelDomainZones = window.thirdLevelDomainZones;
        let currentThirdLevelDomainZone = '';
        enteredQuery = enteredQuery.replace(/[^\p{L}\d\-\.]|_/gu, '').slice(0, 63).toLowerCase();
        if (enteredQuery === '' || enteredQuery.length == 0) {
            return enteredQuery;
        }
        if (enteredQuery.length > 1 && enteredQuery.slice(-1) === '.') {
            enteredQuery = enteredQuery.slice(0, -1);
        }
        if (enteredQuery.length > 4 && enteredQuery.slice(0, 4) === 'www.') {
            enteredQuery = enteredQuery.slice(4);
        }
        if (enteredQuery.length > 4 && enteredQuery.slice(-4) === '.art') {
            enteredQuery = enteredQuery.slice(0, -4);
        }
        if (enteredQuery.indexOf('.') !== -1) {
            for (let thirdLevelDomainZone of thirdLevelDomainZones) {
                if (thirdLevelDomainZone.length > 4 && thirdLevelDomainZone.slice(-4).toLowerCase() === '.art') {
                    thirdLevelDomainZone = thirdLevelDomainZone.slice(0, -4);
                }
                if (enteredQuery.length > thirdLevelDomainZone.length
                    && enteredQuery.slice(-thirdLevelDomainZone.length) === thirdLevelDomainZone.toLowerCase()) {
                    enteredQuery = enteredQuery.slice(0, -thirdLevelDomainZone.length);
                    currentThirdLevelDomainZone = thirdLevelDomainZone;
                    break;
                }
            }
        }
        enteredQuery = enteredQuery.replace(/[\.]|_/gu, '');
        if (currentThirdLevelDomainZone !== '') {
            enteredQuery = enteredQuery + '.' + currentThirdLevelDomainZone;
        }
        if (enteredQuery.length < 5 || (enteredQuery.length > 4 && enteredQuery.slice(0, 4) !== 'xn--')) {
            enteredQuery = enteredQuery.replace(/-+/gu, '-');
        }
        if (enteredQuery.length == 0) {
            return enteredQuery;
        }
        if (enteredQuery.slice(0, 1) === '-') {
            enteredQuery = enteredQuery.slice(1);
        }
        if (enteredQuery.slice(-1) === '-') {
            enteredQuery = enteredQuery.slice(0, -1);
        }
        return enteredQuery;
    }
    /**
     * Загружает домены
     */
    loadDomains(query) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!query) {
                this.renderError(this.translationService.instant('domainSearchErrEmptyForSearch'));
                this.error = true;
                return;
            }
            if (this.end) {
                return;
            }
            this.loader.show();
            this.loading = true;
            this.error = false;
            this.offset++;
            try {
                const { data: { items: domains, ga } } = yield this.domainService.getSearchDomains(query, this.offset);
                if (ga) {
                    const gaService = new ga_1.GaService();
                    gaService.pushGA(ga);
                }
                this.domains = [...this.domains, ...domains];
                this.end = !domains.length;
                yield this.appendDomains(query, this.domains);
            }
            catch (err) {
                this.renderError(err.message || this.translationService.instant('somethingWentWrong'));
                this.error = true;
            }
            finally {
                this.loader.hide();
                this.loading = false;
            }
        });
    }
    /**
     * Добавляет домены в список
     */
    appendDomains(query, domains) {
        return __awaiter(this, void 0, void 0, function* () {
            const similarDomains = domains;
            const primaryIndex = similarDomains.findIndex((d) => d.name === query.toLowerCase().replace('.art', ''));
            const primaryThird = query.toLowerCase().replace('.art', '') + '.art';
            let primary;
            if (primaryIndex !== -1) {
                primary = similarDomains.splice(primaryIndex, 1)[0] || null;
            }
            if (primary) {
                let achievements;
                try {
                    const { data } = yield this.domainService.getDomainAchievements(primary.name);
                    achievements = data;
                }
                catch (_a) { }
                this.renderMatchDomain(primary, achievements);
            }
            else if (this.domainService.isThirdLevelDomain(primaryThird)) {
                let thirdLevelsDomain, primaryThirdLevel;
                try {
                    const { data } = yield this.domainService.getThirdLevelsDomain(primaryThird);
                    thirdLevelsDomain = data;
                }
                catch (_b) { }
                const primaryThirdIndex = thirdLevelsDomain.findIndex((d) => d.name + '.' + d.zone === primaryThird);
                if (primaryThirdIndex !== -1) {
                    primaryThirdLevel = thirdLevelsDomain.splice(primaryThirdIndex, 1)[0] || null;
                }
                this.renderMatchThirdDomain(primaryThirdLevel);
            }
            this.renderSimilarDomains(similarDomains);
        });
    }
    /**
     * Регистрирует обработчик скролла для подгрузки доменов
     */
    registerScrollHandler() {
        const paginator = document.querySelector('.js-search-more-results');
        if (!paginator) {
            return;
        }
        document.addEventListener('scroll', () => {
            if (!this.loading && !this.error && (0, dom_1.inViewpoint)(paginator)) {
                this.loadDomains(this.getQuery());
            }
        });
    }
    /**
     * Генерирует представление категорий
     */
    renderCategories(categories) {
        const container = document.querySelector('.js-search-categories');
        if (!container) {
            return;
        }
        (0, lit_html_1.render)((0, categories_1.getCategoriesTemplate)(container, categories, this.translationService), container);
    }
    /**
     * Генерирует представление основного домена
     */
    renderMatchDomain(domain, achievements) {
        const container = document.querySelector('.search-match-result');
        if (!container) {
            return;
        }
        const achievementsTemplate = (0, achievements_1.getDomainAchievementsTemplate)(achievements, this.translationService);
        (0, lit_html_1.render)((0, primary_1.getPrimaryDomainTemplate)(domain, achievementsTemplate, this.translationService), container);
    }
    /**
     * Генерирует представление основного домена 3го уровня
     */
    renderMatchThirdDomain(domain) {
        const container = document.querySelector('.search-match-result');
        if (!container) {
            return;
        }
        (0, lit_html_1.render)((0, primary_third_level_1.getPrimaryDomainThirdLevelTemplate)(domain, this.translationService), container);
    }
    /**
     * Генерирует представление похожих доменов
     */
    renderSimilarDomains(domains) {
        const container = document.querySelector('.js-similar-result-list');
        if (!container) {
            return;
        }
        if (!domains.length) {
            return;
        }
        const templates = [];
        for (let i = 0; i < domains.length; i++) {
            templates.push((0, simple_1.getSimpleDomainTemplate)(domains[i], this.translationService));
        }
        (0, lit_html_1.render)((0, lit_html_1.html) `${templates}`, container);
        const a = document.querySelector('.search-similar-results');
        if (a) {
            a.style.display = 'block';
        }
    }
    /**
     * Генерирует представление ошибки
     */
    renderError(error) {
        const container = document.querySelector('.js-error-message');
        if (!container) {
            return;
        }
        (0, lit_html_1.render)((0, lit_html_1.html) `
            <div class="search-api-error">${error}</div>
        `, container);
    }
    /**
     * Отслеживает изменение ввода поиска
     */
    registerChangeInputSearch() {
        const inputSearch = document.querySelector('.search-page .search .search__field');
        const enteredQuery = this.getEnteredQuery();
        const hideDotArt = enteredQuery.length > 4 && enteredQuery.toLowerCase().slice(-4) === '.art';
        if (inputSearch) {
            const doubleBlock = document.querySelector('.js-search-result');
            if (!hideDotArt) {
                doubleBlock.parentElement.classList.remove('hidden');
            }
            if (inputSearch.value.length === 0) {
                doubleBlock.textContent = 'example';
            }
            inputSearch.addEventListener('input', (event) => {
                if (doubleBlock) {
                    doubleBlock.textContent = inputSearch.value;
                    if (inputSearch.value.length === 0) {
                        doubleBlock.textContent = 'example';
                    }
                }
            });
            inputSearch.addEventListener('focus', (event) => {
                doubleBlock.parentElement.classList.add('hidden');
            });
            inputSearch.addEventListener('blur', (event) => {
                let lastEnteredQuery = this.getEnteredQuery();
                if (!(lastEnteredQuery.length > 4 && lastEnteredQuery.toLowerCase().slice(-4) === '.art')) {
                    doubleBlock.parentElement.classList.remove('hidden');
                }
            });
        }
    }
};
SearchManager = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [])
], SearchManager);
exports.SearchManager = SearchManager;
